import { render, staticRenderFns } from "./PJShowCard.vue?vue&type=template&id=542991f0&scoped=true"
import script from "./PJShowCard.vue?vue&type=script&lang=js"
export * from "./PJShowCard.vue?vue&type=script&lang=js"
import style0 from "./PJShowCard.vue?vue&type=style&index=0&id=542991f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542991f0",
  null
  
)

export default component.exports